.ugc-review-item-mobile-modal-wrap {
  .review-image-wrap {
    display: flex;
    gap: 6px;
    overflow: hidden;
    .image-item.left {
      display: flex;
      flex-direction: row-reverse;
      width: 16px;
    }
    .image-item.center {
      flex: 1 1 0%;
      > img {
        width: 100%;
      }
    }
    .image-item.right {
      flex: none;
      width: 16px;
    }
  }
}
